import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { ScreenSizeProvider } from '@context/screenSizeContext';
import { SnackbarProvider } from '@context/snackbarContext';

import { store } from '@redux/store';
import Routes from '@configuration/routes';

const queryClient = new QueryClient()

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <SnackbarProvider>
            <ScreenSizeProvider>
              <Router>
                <Routes />
              </Router>
            </ScreenSizeProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
